<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-sky-500" border-bg-to="to-indigo-500" :back-url="route('dashboard')">
            <div>
                <div class="text-xl font-bold">
                    <span>
                        {{ auth.user.name }}
                    </span>
                </div>
                <div class="opacity-50">
                    <span class="flex items-center">
                        <icon name="mail" class="mr-2"/> {{ auth.user.email }}
                    </span>
                </div>
            </div>
        </base-header>

        <base-content>
            <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 items-start">
<!--                <div>-->
<!--                    <update-profile-information-form :user="auth.user"/>-->
<!--                </div>-->

                <div>
                    <update-password-form class="mt-10 sm:mt-0"/>
                </div>
            </div>

            <!--&lt;!&ndash;                <div>&ndash;&gt;-->
            <!--&lt;!&ndash;                    <two-factor-authentication-form class="mt-10 sm:mt-0"/>&ndash;&gt;-->
            <!--&lt;!&ndash;                </div>&ndash;&gt;-->

            <!--                <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0"/>-->
        </base-content>
    </app-layout>
</template>

<script>
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm';
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm';
import UpdatePasswordForm from './UpdatePasswordForm';
import UpdateProfileInformationForm from './UpdateProfileInformationForm';

export default {
    components: {
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },

    props: ['sessions'],
};
</script>
